import Link from "next/link";

import {
  faEquals,
  faCube,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Head from "next/head";

export default function Home() {
  const data = [
    {
      id: 1,
      icon: faEquals,
      link: `/24`,
      title: "24点",
      fulltitle: `24 Point Game`,
    },
    {
      id: 2,
      icon: faCube,
      link: "/JpermAlgorithms-RubiksCube.pdf",
      title: "Rubik's Cube",
      fulltitle: `Rubik's Cube Algorithm`,
    },
    {
      id: 3,
      icon: faQuestionCircle,
      link: `/di`,
      title: "Depression Iventory",
      fulltitle: `BDI and CDI`,
    },
  ];
  return (
    <>
      <Head>
        <title>Shenhe - Home</title>
      </Head>
      <main className="h-screen space-x-20 m-10">
        <div className="flex flex-wrap gap-4">
          {data.map(({ id, icon, link, title, fulltitle }) => (
            <Link
              key={id}
              href={link}
              title={fulltitle}
              className="block card-size max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 content-center"
            >
              <div className="p-6 rounded-lg bg-gray-100 hover:bg-gray-200 dark:hover:bg-gray-800 h-full content-center dark:bg-gray-700 dark:border-gray-700">
                <FontAwesomeIcon
                  icon={icon}
                  className="text-gray-950 mx-auto dark:text-gray-400 size-24"
                />
                <h5 className="mb-2 mt-2 text-sm font-bold tracking-tight mx-auto text-gray-900 dark:text-white text-center">
                  {title}
                </h5>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
